import FetchFacilityUsers from '@Application/Users/FacilityUsers/Queries/FetchFacilityUsers';
import fetchFacilityUsers from '@Application/Users/FacilityUsers/fetchFacilityUsers';
import { PermissionEnum } from '@Application/Security/Roles';
import useHasPermission from '@UI/Providers/PermissionProvider/useHasPermission';
import useStrictCurrentFacility from '@UI/Providers/CurrentFacilityProvider/useStrictCurrentFacility';
import type FacilityUsersListView from '@UI/Store/FacilityUsers/Views/FacilityUsersListView';
import { useDispatch, useStoreQuery } from '@verclam/synapse';
import type { UseStoreQueryResult } from '@verclam/synapse';

/**
 * The directory of the current agency. The route requires `USER_READ`: without it nothing is requested
 * and the value stays `null`.
 */
const useFacilityUsers = (): UseStoreQueryResult<FacilityUsersListView | null> => {
	const dispatch = useDispatch();
	const { currentFacility } = useStrictCurrentFacility();
	const facilityId = currentFacility.id;
	const canReadUsers = useHasPermission(PermissionEnum.USER_READ);

	return useStoreQuery({
		selector: (state) => state.facilityUsersStore.users,
		stopOn: (value) => !canReadUsers || (value !== null && value.facilityId === facilityId),
		query: () => {
			if (!canReadUsers) {
				return Promise.resolve();
			}

			return dispatch(fetchFacilityUsers(new FetchFacilityUsers(facilityId)));
		},
		deps: [facilityId, canReadUsers],
	});
};

export default useFacilityUsers;
